/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Footer/Footer'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HeroBanner',
        import: () => import('@stories/Widgets/HeroBanner/HeroBanner'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'HoldingPage',
        import: () => import('@stories/Widgets/HoldingPage/HoldingPage'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ContentBanner',
        import: () => import('@stories/Widgets/ContentBanner/ContentBanner'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FullWidthCta',
        import: () => import('@stories/Widgets/FullWidthCta/FullWidthCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'SplitCta',
        import: () => import('@stories/Widgets/SplitCta/SplitCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ImageRow',
        import: () => import('@stories/Widgets/ImageRow/ImageRow'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContentCardWithImage',
        import: () => import('@stories/Widgets/ContentCardWithImage/ContentCardWithImage'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'Slideshow',
        import: () => import('@stories/Widgets/Slideshow/Slideshow'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TabbedContentCards',
        import: () => import('@stories/Widgets/TabbedContentCards/TabbedContentCards'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HorizontalTabbedContent',
        import: () => import('@stories/Widgets/HorizontalTabbedContent/HorizontalTabbedContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'VerticalTabbedMedia',
        import: () => import('@stories/Widgets/VerticalTabbedMedia/VerticalTabbedMedia'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'CoverImageCta',
        import: () => import('@stories/Widgets/CoverImageCta/CoverImageCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StaggeredImageCta',
        import: () => import('@stories/Widgets/StaggeredImageCta/StaggeredImageCta'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ApartmentList',
        import: () => import('@stories/Widgets/ApartmentList/ApartmentList'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TravelTimes',
        import: () => import('@stories/Widgets/TravelTimes/TravelTimes'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'PoiMap',
        import: () => import('@stories/Widgets/PoiMap/PoiMap'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'TiledMasonryGallery',
        import: () => import('@stories/Widgets/TiledMasonryGallery/TiledMasonryGallery'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ContactForm',
        import: () => import('@stories/Widgets/ContactForm/ContactForm'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'HtmlSiteMap',
        import: () => import('@stories/Widgets/HtmlSiteMap/HtmlSiteMap'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'ImageTextContent',
        import: () => import('@stories/Widgets/ImageTextContent/ImageTextContent'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'UspCardListing',
        import: () => import('@stories/Widgets/UspCardListing/UspCardListing'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'FloatingCtaEnquiryButton',
        import: () => import('@stories/Widgets/FloatingCtaEnquiryButton/FloatingCtaEnquiryButton'),
        config: {
            hydrate: 'in-view',
        },
    }
];
